import { functionFrom, FunctionLibrary, getFunctionSignature } from '../FunctionDefinition';
import { TYPES } from '../Types';

const add = functionFrom(
  'add',
  [
    { name: 'a', type: TYPES.number },
    { name: 'b', type: TYPES.number },
  ] as const,
  TYPES.number,
  (_ctx, a, b) => a + b,
  'Adds two numbers.',
);
const subtract = functionFrom(
  'subtract',
  [
    { name: 'a', type: TYPES.number },
    { name: 'b', type: TYPES.number },
  ] as const,
  TYPES.number,
  (_ctx, a, b) => a - b,
  'Subtracts the second number from the first.',
);
const multiply = functionFrom(
  'multiply',
  [
    { name: 'a', type: TYPES.number },
    { name: 'b', type: TYPES.number },
  ] as const,
  TYPES.number,
  (_ctx, a, b) => a * b,
  'Multiplies two numbers.',
);
const divide = functionFrom(
  'divide',
  [
    { name: 'a', type: TYPES.number },
    { name: 'b', type: TYPES.number },
  ] as const,
  TYPES.number,
  (_ctx, a, b) => a / b,
  'Divides the first number by the second. Division by zero yields `Infinity` or `-Infinity`.',
);
const mod = functionFrom(
  'mod',
  [
    { name: 'a', type: TYPES.number },
    { name: 'b', type: TYPES.number },
  ] as const,
  TYPES.number,
  (_ctx, a, b) => a % b,
  'Remainder of dividing `a` by `b` (JavaScript `%` semantics).',
);
const pow = functionFrom(
  'pow',
  [
    { name: 'a', type: TYPES.number },
    { name: 'b', type: TYPES.number },
  ] as const,
  TYPES.number,
  (_ctx, a, b) => a ** b,
  'Exponentiation: `a` raised to the power `b`.',
);
const sqrt = functionFrom(
  'sqrt',
  [{ name: 'a', type: TYPES.number }] as const,
  TYPES.number,
  (_ctx, a) => Math.sqrt(a),
  'Square root of a number. Negative inputs yield NaN.',
);
const abs = functionFrom(
  'abs',
  [{ name: 'a', type: TYPES.number }] as const,
  TYPES.number,
  (_ctx, a) => Math.abs(a),
  'Absolute value of a number.',
);
const round = functionFrom(
  'round',
  [{ name: 'a', type: TYPES.number }] as const,
  TYPES.number,
  (_ctx, a) => Math.round(a),
  'Rounds a number to the nearest integer using half-away-from-zero.',
);
const floor = functionFrom(
  'floor',
  [{ name: 'a', type: TYPES.number }] as const,
  TYPES.number,
  (_ctx, a) => Math.floor(a),
  'Rounds a number toward negative infinity.',
);
const ceil = functionFrom(
  'ceil',
  [{ name: 'a', type: TYPES.number }] as const,
  TYPES.number,
  (_ctx, a) => Math.ceil(a),
  'Rounds a number toward positive infinity.',
);

export const MATH_FUNCTIONS = {
  [getFunctionSignature(add)]: add,
  [getFunctionSignature(subtract)]: subtract,
  [getFunctionSignature(multiply)]: multiply,
  [getFunctionSignature(divide)]: divide,
  [getFunctionSignature(mod)]: mod,
  [getFunctionSignature(pow)]: pow,
  [getFunctionSignature(sqrt)]: sqrt,
  [getFunctionSignature(abs)]: abs,
  [getFunctionSignature(round)]: round,
  [getFunctionSignature(floor)]: floor,
  [getFunctionSignature(ceil)]: ceil,
} satisfies FunctionLibrary;
